import React, { useEffect, useState, useRef } from "react";

import { getMessages, sendMessage } from "../../ReduxTLK/features/Chat/ChatSlice";

import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { Drawer, Avatar, Badge, Typography, Tooltip } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';

import ChatIcon from "../IconComponents/ChatIcon";
import { Button } from "@mui/material";
import Box from '@mui/material/Box';
import ErrorBox from "../Alerts/ErrorBox";
import { fetchCauses } from "../../ReduxTLK/features/Causes/CauseSlice";
import ChatComposer from "./ChatComposer";
import ChatMessageList from "./ChatMessageList";
import { isStatusMessage } from "./chatTimeline";

const ALLOWED_FILE_TYPES = ['png', 'jpg', 'jpeg', 'gif', 'pdf', 'docx', 'doc', 'xlsx'];
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
const FONT = '"DM Sans", sans-serif';

const hasFiles = (event) => Array.from(event.dataTransfer?.types || []).includes('Files');

export default function ChatComponent(props) {
  const dispatch = useDispatch()
  const userId = localStorage.getItem('userId')
  const userlastName = localStorage.getItem('userlastName')
  const connectionId = localStorage.getItem('connectionId')
  const [array_causes, setArray_causes] = useState([])
  const [open, setOpen] = useState(false);
  const [openErrorBox, setOpenErrorBox] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [uploading, setUploading] = useState(false)
  const [dragging, setDragging] = useState(false)
  const dragDepth = useRef(0)
  const inputFile = useRef(null)

  const messageCount = props.messagesList?.filter((message) => !isStatusMessage(message)).length ?? 0

  const openDialog = () => {
    setOpen(true);
    // lets the ticket page know the chat is open (no unread badge while the agent is reading)
    props.setOpen?.(true)
  }

  const handleClose = () => {

    const data = {
      idTicket: props.openTicket,
      page: 1,
      pageSize: 1000
    }
    dispatch(getMessages(data))
    setOpen(false)
    props.setOpen?.(false)
    props.setNbreMessagesNonLus(0)
  }

  useEffect(() => {
    //props.joinRoomFunction();
    if (props.openTicket == !undefined || props.openTicket == ! null) {
      props.fetchMessages();
    }
  }, []);

  useEffect(() => {
    dispatch(fetchCauses()).then((response) => {
      setArray_causes(response.payload?.data?.data?.result ?? [])
    })
  }, [])

  const showError = (text) => {
    setErrorMessage(text)
    setOpenErrorBox(true)
  }

  // Returns true when the message was sent, so the composer only clears the text on success
  const handleSendMessage = async (textContent) => {

    props.setNbreMessagesNonLus(0)
    const form = new FormData();
    form.append('contenu', encodeURIComponent(textContent))
    form.append('idTicket', props.openTicket)
    form.append('connectionId', connectionId)
    form.append('isUpdateStatut', false)
    try {
      await dispatch(sendMessage(form)).then(unwrapResult)
      props.setMessagesList((prevMessagesList) => [
        ...prevMessagesList,
        {
          localId: `local-${Date.now()}`,
          contenu: textContent,
          sender: {
            id: userId,
            nom: userlastName
          },
          date: new Date().toISOString(),
        },
      ])
      return true
    }
    catch (err) {
      showError("Le message n'a pas pu être envoyé. Votre texte a été conservé, veuillez réessayer.")
      return false
    }
  }

  /*********file input */
  const handleAttach = () => {
    //  open file input box on click of another element
    inputFile.current.click();
  };

  const uploadFile = async (fileObj) => {

    props.setNbreMessagesNonLus(0)

    // File type check
    if (!ALLOWED_FILE_TYPES.includes(fileObj?.name?.toLowerCase().split('.').pop())) {
      showError('Type de fichier invalide. Les types de fichiers autorisés sont PNG, JPG, JPEG, GIF, PDF, DOC ou XLS.')
      return;
    }

    // File size check
    if (fileObj?.size > MAX_FILE_SIZE) {
      showError('La taille du fichier dépasse la taille maximale autorisée (5 Mo).')
      return;
    }

    const form = new FormData();
    form.append('attachement', fileObj);
    form.append('contenu', '')
    form.append('idTicket', props.openTicket)
    form.append('connectionId', connectionId)
    form.append('isUpdateStatut', false)
    setUploading(true)
    try {
      await dispatch(sendMessage(form)).then(unwrapResult)
      props.fetchAttachments?.({
        pageSize: 7,
        page: 1,
        nbPage: 0,
        idTicket: props.openTicket
      })
      props.fetchMessages()
      // the attachment can take a moment to be available on the server
      setTimeout(() => {
        props.fetchMessages();
      }, 2000);
    }
    catch (err) {
      showError(`« ${fileObj.name} » n'a pas pu être envoyé. Veuillez réessayer.`)
    }
    finally {
      setUploading(false)
    }
  }

  const handleFileChange = event => {
    const fileObj = event.target.files && event.target.files[0];
    // allow picking the same file again later
    event.target.value = '';
    if (fileObj) uploadFile(fileObj);
  }

  /********* drag & drop files on the chat */
  const handleDragEnter = (event) => {
    if (props.disableInput || !hasFiles(event)) return;
    event.preventDefault();
    dragDepth.current += 1;
    setDragging(true);
  }
  const handleDragOver = (event) => {
    if (props.disableInput || !hasFiles(event)) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  }
  const handleDragLeave = (event) => {
    if (props.disableInput || !hasFiles(event)) return;
    dragDepth.current -= 1;
    if (dragDepth.current <= 0) {
      dragDepth.current = 0;
      setDragging(false);
    }
  }
  const handleDrop = async (event) => {
    if (props.disableInput || !hasFiles(event)) return;
    event.preventDefault();
    dragDepth.current = 0;
    setDragging(false);
    for (const file of Array.from(event.dataTransfer.files)) {
      await uploadFile(file);
    }
  }

  return (
    <>
      <div style={{ backgroundColor: 'white', minWidth: '153px', minHeight: '48px' }}>
        <Button
          sx={{
            display: 'flex',
            padding: '10px 14px',
            justifyContent: 'center',
            textTransform: 'none',
            alignItems: 'center',
            gap: 'var(--spacing-3xs, 2px)',
            borderRadius: '6px',
            height: '40px',
            background: 'var(--Base-White, #FFF)',
            boxShadow: '0px 0px 2px 0.15px rgba(16, 24, 40, 0.1), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
            marginRight: '-200px'
          }}
          type="primary" onClick={openDialog} size="small">
          <Box component="span" sx={{ display: 'inline-flex', p: '5px' }}>
            <ChatIcon />
          </Box>
          <Typography sx={{
            color: '#344054',
            fontFamily: "DM Sans",
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '24px',
          }}>Chat</Typography>
          {props.nbreMessagesNonLus > 0 && (
            <Badge
              color="primary"
              sx={{
                display: 'flex',
                ml: 1,
                width: 25,
                height: 20,
                padding: '0px 8px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                borderRadius: '12px',
                background: 'var(--secondary-400-base, #1671D9)',
              }}>
              <Typography sx={{ color: 'white' }} >{props.nbreMessagesNonLus}</Typography>
            </Badge>
          )}
        </Button>
        <Box sx={{ position: 'relative', bottom: 0, right: 0 }} >
          <Drawer
            open={open}
            variant='persistent'
            hideBackdrop
            anchor="bottom"
            PaperProps={{
              sx: {
                height: '73%',
                width: '30%',
                minWidth: 380,
                position: 'fixed',
                marginLeft: "auto",
                marginRight: 2,
                // header + messages (fill the remaining height) + composer pinned at the bottom
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                border: '1px solid #EAECF0',
                borderRadius: '12px',
                boxShadow: '0 12px 32px rgba(16, 24, 40, 0.16)',
              },
            }}
          >
            <Box
              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              sx={{ position: 'relative', flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
            >
              {/* Header */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, borderBottom: '1px solid #EAECF0', flexShrink: 0 }}>
                <Avatar sx={{ width: 36, height: 36, bgcolor: '#E8F1FC', color: '#1671D9' }}>
                  <ForumRoundedIcon fontSize="small" />
                </Avatar>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography noWrap sx={{ fontFamily: FONT, fontSize: '15px', fontWeight: 600, color: '#101828', lineHeight: '22px' }}>
                    Ticket {props.pageTitle}
                  </Typography>
                  <Typography noWrap sx={{ fontFamily: FONT, fontSize: '12px', color: '#667085' }}>
                    {props.disableInput ? 'Lecture seule' : 'Conversation client'} · {messageCount} message{messageCount > 1 ? 's' : ''}
                  </Typography>
                </Box>
                <Tooltip title="Fermer">
                  <IconButton aria-label="close" onClick={handleClose} size="small" sx={{ color: '#667085' }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>

              <ChatMessageList
                messages={props.messagesList}
                userId={userId}
                causes={array_causes}
                active={open}
              />

              {props.disableInput ? <></> :
                <ChatComposer
                  ticketId={props.openTicket}
                  ticketLabel={props.pageTitle}
                  onSend={handleSendMessage}
                  onAttachClick={handleAttach}
                  attaching={uploading}
                  autoFocus={open}
                />
              }

              {dragging && (
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 8,
                    zIndex: 2,
                    borderRadius: '12px',
                    border: '2px dashed #1671D9',
                    bgcolor: 'rgba(232, 241, 252, 0.94)',
                    color: '#1671D9',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    pointerEvents: 'none',
                  }}
                >
                  <CloudUploadRoundedIcon sx={{ fontSize: 40 }} />
                  <Typography sx={{ fontFamily: FONT, fontSize: '15px', fontWeight: 600 }}>Déposez le fichier pour l'envoyer</Typography>
                  <Typography sx={{ fontFamily: FONT, fontSize: '12px', color: '#475467' }}>PNG, JPG, GIF, PDF, DOC, XLSX — 5 Mo max</Typography>
                </Box>
              )}
            </Box>

            <input
              type='file'
              id='file'
              ref={inputFile}
              style={{ display: 'none' }}
              accept={ALLOWED_FILE_TYPES.map((type) => `.${type}`).join(',')}
              onChange={handleFileChange}
            />

            <ErrorBox severity={'error'} message={errorMessage} open={openErrorBox} setOpen={setOpenErrorBox} autoHideDuration={1000} />
          </Drawer>

        </Box >
      </div>

    </>
  )
}
